// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RelatedPapersSidebar-cls1___c421c43a4a88534f438{/*!*/}.RelatedPapersSidebar-cls2___6a03bc7a2fc3e9e08e8{margin-top:24px;margin-top:var(--spacing-sm-24, 24px);padding-bottom:24px;padding-bottom:var(--spacing-sm-24, 24px);flex:1 1;display:flex;flex-direction:column;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "RelatedPapersSidebar-cls1___c421c43a4a88534f438",
	"cls2": "RelatedPapersSidebar-cls2___6a03bc7a2fc3e9e08e8 RelatedPapersSidebar-cls1___c421c43a4a88534f438"
};
export default ___CSS_LOADER_EXPORT___;
